import { abs } from "mathjs";
import React from "react";

export const ShowTableDataTriangle = (value: number) => {
  return (
    <React.Fragment>
      {value < 0 ? (
        <span>
          ▲
          {String(abs(Math.round(value))).replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            "$1,"
          )}
        </span>
      ) : (
        String(Math.round(value)).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
      )}
    </React.Fragment>
  );
};
